import React, { ReactNode } from 'react';
import { IconTooltip } from './IconTooltip';

interface DetailItemProps {
    label: string;
    value: ReactNode;
    icon?: ReactNode;
    variant?: 'horizontal' | 'vertical';
    bordered?: boolean;
    className?: string;
    iconClassName?: string;
}

export const DetailItem: React.FC<DetailItemProps> = ({
    label,
    value,
    icon,
    variant = 'vertical',
    bordered = false,
    className = '',
    iconClassName = ''
}) => {
    if (variant === 'horizontal') {
        return (
            <div className={`flex items-center justify-between p-4 rounded-2xl border border-secondary/20 bg-secondary/5 group transition-colors hover:border-primary/20 ${className}`}>
                <div className="flex flex-col">
                    <span className="text-xs font-bold text-muted-foreground uppercase tracking-widest mb-0.5">{label}</span>
                    <span className="font-bold text-sm text-foreground">{value}</span>
                </div>
                {icon && (
                    <IconTooltip content={label}>
                        <div className={`p-2.5 rounded-xl bg-primary/10 text-primary ${iconClassName}`}>
                            {icon}
                        </div>
                    </IconTooltip>
                )}
            </div>
        );
    }

    return (
        <div className={`flex items-start gap-4 ${bordered ? 'p-4 rounded-xl border bg-card shadow-sm' : ''} ${className}`}>
            {icon && (
                <IconTooltip content={label}>
                    <div className={`mt-1 p-2 bg-secondary/50 rounded-lg shrink-0 ${iconClassName}`}>
                        {React.isValidElement(icon) && React.cloneElement(icon as React.ReactElement<any>, { 
                            className: 'w-4 h-4 text-muted-foreground' 
                        })}
                    </div>
                </IconTooltip>
            )}
            <div className="flex flex-col min-w-0">
                <p className="text-[10px] font-bold text-muted-foreground uppercase tracking-wider mb-0.5">{label}</p>
                <div className="text-sm font-semibold text-foreground leading-snug break-words">
                    {value || 'N/A'}
                </div>
            </div>
        </div>
    );
};
